module.exports = __webpack_public_path__ + "html/top-layout_e5d1e3956fb378f1c34b290c14f2c740.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/top-layout.html
// module id = 23em
// module chunks = 55